import { createStructuredSelector } from 'reselect'
import {
  MGMT_OUTCOME_LIST, MGMT_OUTCOME_LIST_SUCCESS, MGMT_OUTCOME_LIST_ERROR,
  MGMT_OUTCOME_PAGE_SET, MGMT_OUTCOME_ADD, MGMT_OUTCOME_ADD_SUCCESS,
  MGMT_OUTCOME_ADD_ERROR, MGMT_OUTCOME_ADD_CHANGE, MGMT_OUTCOME_DETAIL,
  MGMT_OUTCOME_DETAIL_SUCCESS, MGMT_OUTCOME_DETAIL_ERROR, MGMT_OUTCOME_UPDATE,
  MGMT_OUTCOME_UPDATE_SUCCESS, MGMT_OUTCOME_UPDATE_ERROR,
} from '../../actions';

export const NAME = 'mgmt_outcome';

export const MgmtOutcomeList = (page, num_page, orderBy, filters) => ({ type: MGMT_OUTCOME_LIST, payload: { page, num_page, orderBy, filters } });
export const MgmtOutcomeListSuccess = (data) => ({ type: MGMT_OUTCOME_LIST_SUCCESS, payload: data });
export const MgmtOutcomeListError = (error) => ({ type: MGMT_OUTCOME_LIST_ERROR, payload: error });
export const MgmtOutcomePageSet = (data) => ({ type: MGMT_OUTCOME_PAGE_SET, payload: data });
export const MgmtOutcomeAddChangeSet = (data) => ({ type: MGMT_OUTCOME_ADD_CHANGE, payload: data });
export const MgmtOutcomeAdd = (data) => ({ type: MGMT_OUTCOME_ADD, payload: data });
export const MgmtOutcomeAddSuccess = (message) => ({ type: MGMT_OUTCOME_ADD_SUCCESS, payload: message });
export const MgmtOutcomeAddError = (error) => ({ type: MGMT_OUTCOME_ADD_ERROR, payload: error });
export const MgmtOutcomeDetail = (data) => ({ type: MGMT_OUTCOME_DETAIL, payload: data });
export const MgmtOutcomeDetailSuccess = (data) => ({ type: MGMT_OUTCOME_DETAIL_SUCCESS, payload: data });
export const MgmtOutcomeDetailError = (error) => ({ type: MGMT_OUTCOME_DETAIL_ERROR, payload: error });
export const MgmtOutcomeUpdate = (data) => ({ type: MGMT_OUTCOME_UPDATE, payload: data });
export const MgmtOutcomeUpdateSuccess = (message) => ({ type: MGMT_OUTCOME_UPDATE_SUCCESS, payload: message.message });
export const MgmtOutcomeUpdateError = (error) => ({ type: MGMT_OUTCOME_UPDATE_ERROR, payload: error });

const mgmt_outcome = (state) => state[NAME];
export const MgmtOutcomeSelector = createStructuredSelector({ mgmt_outcome });
